import { render, staticRenderFns } from "./kv-color-input.vue?vue&type=template&id=37c3de29"
import script from "./kv-color-input.vue?vue&type=script&lang=js"
export * from "./kv-color-input.vue?vue&type=script&lang=js"
import style0 from "./kv-color-input.vue?vue&type=style&index=0&id=37c3de29&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports